// src/components/TransactionNotification/TransactionNotificationWrapper.js
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import TransactionNotification from './TransactionNotification';

/**
 * A wrapper component that provides imperative API for the TransactionNotification
 * This allows direct control of the notification state from parent components
 */
const TransactionNotificationWrapper = forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [status, setStatus] = useState('processing');
  const [txnHash, setTxnHash] = useState('');
  const [explorerUrl, setExplorerUrl] = useState('');

  // Expose methods to control the notification
  useImperativeHandle(ref, () => ({
    // Show the notification in processing state
    showProcessing: (url) => {
      console.log('TransactionNotificationWrapper: showProcessing called');
      setStatus('processing');
      setTxnHash('');
      if (url) setExplorerUrl(url);
      setIsVisible(true);
    },

    // Update to success state with a transaction hash
    showSuccess: (hash, url) => {
      console.log('TransactionNotificationWrapper: showSuccess called with hash', hash);
      
      // Set data first before changing status
      if (hash) setTxnHash(hash);
      if (url) setExplorerUrl(url);
      
      // Important: Use a small delay to ensure state is updated properly
      // This prevents race conditions between setting hash and changing status
      setTimeout(() => {
        setStatus('success');
        setIsVisible(true); // Ensure it's visible
      }, 10);
    },

    // Hide the notification
    hide: () => {
      console.log('TransactionNotificationWrapper: hide called');
      setIsVisible(false);
    },

    // Update just the transaction hash
    updateHash: (hash) => {
      console.log('TransactionNotificationWrapper: updateHash called with hash', hash);
      setTxnHash(hash);
    }
  }));

  return (
    <TransactionNotification
      isVisible={isVisible}
      status={status}
      txnHash={txnHash}
      explorerUrl={explorerUrl}
      onClose={() => {
        console.log('TransactionNotificationWrapper: onClose callback triggered');
        setIsVisible(false);
      }}
    />
  );
});

export default TransactionNotificationWrapper;